<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/']">
                  <i class=" fas fa-home"></i>
                </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/organization']"> Organization </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/contracts']"> Contract </a>
              </li>

            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
<div class=" container-fluid mt--6">
  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div formGroupName="contactInfo" class=" row">
      <div class=" col-lg">
        <div class=" card-wrapper">

          <div >
            <div   class="card">
              <div class="card-header d-flex justify-content-between">
                <span>Contact</span>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">First Name</label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': contactForm.get('contactInfo.firstName')?.invalid
                               && contactForm.get('contactInfo.firstName')?.touched }"
                               formControlName="firstName" class="form-control">
                        <div
                          *ngIf="contactForm.get('contactInfo.firstName')?.invalid     && contactForm.get('contactInfo.firstName')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="contactForm.get('contactInfo.firstName')?.hasError('required')">
                            First Name is required.
                          </div>
                          <div *ngIf="contactForm.get('contactInfo.firstName')?.hasError('maxlength')">
                            First Name cannot
                            exceed {{ contactForm.get('contactInfo.firstName')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">Last Name</label>
                      <div class="col-md-9">
                        <input
                          [ngClass]="{ 'is-invalid': contactForm.get('contactInfo.lastName')?.invalid
                               && contactForm.get('contactInfo.lastName')?.touched }"
                          type="text" formControlName="lastName" class="form-control">

                        <div
                          *ngIf="contactForm.get('contactInfo.lastName')?.invalid     && contactForm.get('contactInfo.lastName')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="contactForm.get('contactInfo.lastName')?.hasError('required')">
                            Last Name is required.
                          </div>
                          <div *ngIf="contactForm.get('contactInfo.lastName')?.hasError('maxlength')">
                            Last Name cannot
                            exceed {{ contactForm.get('contactInfo.lastName')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">Position</label>
                      <div class="col-md-9">
                        <input type="text" formControlName="position"
                               [ngClass]="{ 'is-invalid': contactForm.get('contactInfo.position')?.invalid
                               && contactForm.get('contactInfo.position')?.touched }"
                               class="form-control">
                        <div
                          *ngIf="contactForm.get('contactInfo.position')?.invalid     && contactForm.get('contactInfo.position')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="contactForm.get('contactInfo.position')?.hasError('required')">
                            Position is required.
                          </div>
                          <div *ngIf="contactForm.get('contactInfo.position')?.hasError('maxlength')">
                            Position cannot
                            exceed {{ contactForm.get('contactInfo.position')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">Email</label>
                      <div class="col-md-9">
                        <input type="email" formControlName="email"
                               [ngClass]="{ 'is-invalid': contactForm.get('contactInfo.email')?.invalid
                               && contactForm.get('contactInfo.email')?.touched }"
                               class="form-control">
                        <div
                          *ngIf="contactForm.get('contactInfo.email')?.invalid     && contactForm.get('contactInfo.email')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="contactForm.get('contactInfo.email')?.hasError('required')">
                            Email is required.
                          </div>
                          <div *ngIf="contactForm.get('contactInfo.email')?.hasError('maxlength')">
                            Email cannot
                            exceed {{ contactForm.get('contactInfo.email')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">Phone</label>
                      <div class="col-md-9">
                        <input type="tel" formControlName="phone"
                               [ngClass]="{ 'is-invalid': contactForm.get('contactInfo.phone')?.invalid
                               && contactForm.get('contactInfo.phone')?.touched }"
                               class="form-control">
                        <div
                          *ngIf="contactForm.get('contactInfo.phone')?.invalid     && contactForm.get('contactInfo.phone')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="contactForm.get('contactInfo.phone')?.hasError('required')">
                            Phone is required.
                          </div>
                          <div *ngIf="contactForm.get('contactInfo.phone')?.hasError('maxlength')">
                            Phone cannot
                            exceed {{ contactForm.get('contactInfo.phone')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">Preferred Method of Contact</label>
                      <div class="col-md-9">
                        <select formControlName="contactMethodId"
                                [ngClass]="{ 'is-invalid': contactForm.get('contactInfo.contactMethodId')?.invalid
                               && contactForm.get('contactInfo.contactMethodId')?.touched }"
                                class="form-control">
                          <option *ngFor="let method of contactMethods" [value]="method.id">
                            {{ method.name }}
                          </option>
                        </select>
                        <div
                          *ngIf="contactForm.get('contactInfo.contactMethodId')?.invalid     && contactForm.get('contactInfo.contactMethodId')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="contactForm.get('contactInfo.contactMethodId')?.hasError('required')">
                            Preferred Method of Contact is required.
                          </div>
                          <div *ngIf="contactForm.get('contactInfo.contactMethodId')?.hasError('maxlength')">
                            Preferred Method of Contact cannot
                            exceed {{ contactForm.get('contactInfo.contactMethodId')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>



          <div class="card">
            <div class="card-body">
              <button class="btn btn-primary" type="submit">Submit</button>
              <button type="button" class="btn btn-secondary" [routerLink]="['/organization']">Back</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

</div>





